import GkGameComponent from "../components/quizcom/GkGameComponent";

const GkGame = () => {
  return <GkGameComponent />;
};

export default GkGame;
